import { FormattedMessage } from 'react-intl'
import { SummaryRow, Tag } from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { MaxPrice } from '../../../../../typings'
import styles from '../styles'
import { ReviewProps } from './constants'
import { messages } from './messages'

type Props = ReviewProps & {
  config: MaxPrice
}

export function MaxPriceReview(props: Props) {
  const { config } = props
  const { formatCurrency } = useNumbers()

  return (
    <SummaryRow.Value className={styles.flexRow}>
      <FormattedMessage
        {...messages.maxPrice}
        values={{
          tag: (content) => <Tag>{content}</Tag>,
          discount: formatCurrency(config.value),
        }}
      />
    </SummaryRow.Value>
  )
}
